import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  AuthRedirectService,
  AuthService,
  CmsConfig, ConfigModule,

  GlobalMessageService,

  I18nModule,


  RoutingService, UrlModule
} from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { UserPasswordFacade } from '@spartacus/user/profile/root';
import { CustomIconsModule } from "../../../../../custom/icons/custom-icons.module";
import { CustomUpdatePasswordComponentService } from './custom-update-password-component.service';
import { CustomUpdatePasswordComponent } from './custom-update-password.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    I18nModule,
    FormErrorsModule,
    UrlModule,
    RouterModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        UpdatePasswordComponent: {
          component: CustomUpdatePasswordComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: CustomUpdatePasswordComponentService,
      useClass: CustomUpdatePasswordComponentService,
      deps: [
        UserPasswordFacade,
        RoutingService,
        GlobalMessageService,
        AuthRedirectService,
        AuthService,
      ],
    },
  ],
  declarations: [CustomUpdatePasswordComponent],
})
export class CustomUpdatePasswordModule { }
